import React, { useEffect, useState } from 'react';
const buyers = [{
  n: 'Elena R.',
  c: 'Madrid'
}, {
  n: 'Andrés M.',
  c: 'Ciudad de México'
}, {
  n: 'Ricardo G.',
  c: 'Medellín'
}, {
  n: 'Sofía T.',
  c: 'Buenos Aires'
}, {
  n: 'Javier L.',
  c: 'Barcelona'
}, {
  n: 'Mateo S.',
  c: 'Santiago'
}, {
  n: 'Valentina P.',
  c: 'Miami'
}, {
  n: 'Diego C.',
  c: 'Bogotá'
}, {
  n: 'Isabella V.',
  c: 'Lima'
}, {
  n: 'Carlos B.',
  c: 'Valencia'
}, {
  n: 'Lucía D.',
  c: 'Sevilla'
}, {
  n: 'Hernán J.',
  c: 'Quito'
}, {
  n: 'Gabriela F.',
  c: 'Panamá'
}, {
  n: 'Roberto K.',
  c: 'San José'
}, {
  n: 'Paola M.',
  c: 'USA Latam'
}, {
  n: 'Fernando S.',
  c: 'Asunción'
}, {
  n: 'Claudia H.',
  c: 'Guatemala'
}, {
  n: 'Ignacio R.',
  c: 'Montevideo'
}, {
  n: 'Mónica P.',
  c: 'Alicante'
}, {
  n: 'Alejandro Z.',
  c: 'Cancún'
}, {
  n: 'Beatriz N.',
  c: 'Puebla'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showNotification = () => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setBuyer(randomBuyer);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    // First notification after 5 seconds
    const initialTimeout = setTimeout(showNotification, 5000);
    // Then every 30 seconds
    const interval = setInterval(showNotification, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <div role="status" aria-live="polite" className={`fixed bottom-4 left-4 right-4 sm:right-auto sm:left-5 sm:bottom-5 z-[10000] bg-dark/95 border border-gold/30 px-4 py-3 sm:px-5 sm:py-4 rounded-lg shadow-[0_10px_30px_rgba(0,0,0,0.5)] max-w-[340px] sm:max-w-none transition-all duration-500 ease-out transform ${visible ? 'translate-y-0 opacity-100' : 'translate-y-[150px] opacity-0 pointer-events-none'}`} data-id="element-149">
      <div className="flex items-center gap-3" data-id="element-150">
        <span className="text-xl" aria-hidden="true" data-id="element-151">
          💰
        </span>
        <div className="text-[11px] leading-[1.4]" data-id="element-152">
          <span className="font-extrabold text-gold" data-id="element-153">{buyer.n}</span>
          <span className="text-white" data-id="element-154"> de </span>
          <span className="text-white" data-id="element-155">{buyer.c}</span>
          <br data-id="element-156" />
          <span className="text-white/75 text-[10px] uppercase tracking-[1px]" data-id="element-157">
            Acaba de activar el Código 888
          </span>
        </div>
      </div>
    </div>;
}